export default "__VITE_ASSET__44fe12fd__"